module.exports = function (fox) {
	var rules = fox.Validator._._helpers;

	return function (rule) {
		if (!(rule.validator in rules)) {
			throw new TypeError('No such "' + rule.validator + '" validator')
		}

		var ruleInstance = new rules[rule.validator]()
			.setMessage(rule.message || 'Value is invalid')
			.setOptions(rule.options || {});

		return function (value) {
			var result = ruleInstance.setValue(value).validate();

			return {
				result: result,
				message: ruleInstance.getMessage()
			};
		};
	};
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/newForm/validator/foxValidatorShim.js
// module id = 93
// module chunks = 0